export default __webpack_public_path__ + "static/media/business-3d.51b7f494.webp";